import type { StudentPortfolioActivityChainResource } from "api/generated";
import type { ActivityChainItem } from "portfolio/types";

export const activityChainItemFromDto = (
  resource: StudentPortfolioActivityChainResource,
): ActivityChainItem => ({
  id: resource.id,
  title: resource.title,
  status: resource.status,
  date: resource.date ? new Date(resource.date) : null,
});
